/**
 * FP3-029 / FP3-029A — Admin entry point to the shared
 * ImportStudentsPage component. Wraps it in admin mode and gates
 * behind the existing ProtectedRoute(adminOnly).
 */
import ImportStudentsPage from "@/pages/ImportStudentsPage";

export default function AdminImport() {
  return <ImportStudentsPage mode="admin" />;
}
